const axiosPromise = import(/* webpackChunkName: "axios" */ 'axios')

import * as types from '../actionTypes'
import UrlUtil from "../../utils/urlUtil"

const url = new UrlUtil('/api/todo')

export const searchTodo = (searchTerm) => {
  return async (dispatch, getState) => {
    const searchTermToUse = searchTerm || getState().todolist.searchTerm
    if (searchTermToUse) {
      dispatch({type: types.TODO_SEARCH_REQUEST, payload: searchTermToUse})
      const axios = (await axiosPromise).default
      const result = await axios.get(url.makeUrl(['search', searchTermToUse]))
      dispatch({
        type: types.TODO_SEARCH_RESULTS, payload:
            {searchTerm: searchTermToUse, data: result && result.data}
      })
    }
  }
}

export const navigateToPayCargoToFinishPayment = (paymentReqNo, lhub) => {
  return async () => {
    const axios = (await axiosPromise).default
    const result = await axios.get(url.makeUrl(['getPayCargoUrl', paymentReqNo, lhub]))
    const payCargoUrl = result && result.data
    if (payCargoUrl) {
      window.open(payCargoUrl, 'payCargo')
    }
  }
}

export const setSearchTerm = (searchTerm) => {
  return (dispatch) => {
    dispatch({type: types.SET_SEARCH_TERM, payload: searchTerm})
  }
}

export const clearData = () => {
  return (dispatch) => {
    dispatch({type: types.TODO_CLEAR_DATA})
  }
}